import axios from "axios";
import React, { useEffect, useState, useRef } from "react";
import "../../assets/k3/css/k3.css";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "lucide-react";
import io from "socket.io-client";
const base_url = process.env.REACT_APP_API_URL;

const numberData = [
  { name: "2", display: "2" },
  { name: "3", display: "3" },
  { name: "4", display: "4" },
  { name: "5", display: "5" },
  { name: "6", display: "6" },
  { name: "7", display: "7" },
  { name: "8", display: "8" },
  { name: "9", display: "9" },
  { name: "10", display: "10" },
  { name: "11", display: "11" },
  { name: "12", display: "12" },
];

const diceImages = [
  "/assets/k3/images/bg1.png",
  "/assets/k3/images/bg2.png",
  "/assets/k3/images/bg3.png",
  "/assets/k3/images/bg4.png",
  "/assets/k3/images/bg5.png",
  "/assets/k3/images/bg6.png",
];

const getDisplayByBet = (bet) => {
  const item = numberData.find((d) => d.name === bet);
  return item ? item.display : "?";
};

const getDiceDisplay = (num) => {
  return diceImages[num - 1] || null;
};

const K3 = () => {
  const token = localStorage.getItem("token");
  const navigate = useNavigate();
  const [popupActive, setPopupActive] = useState(false);
  const [activeTab, setActiveTab] = useState("game");
  const [activeType, setActiveType] = useState("TOTAL"); // tab
  const [selected, setSelected] = useState([]);
  const [balance, setBalance] = useState(10);
  const [timmer, setTimmer] = useState(60);
  const limit = 10;
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [page2, setPage2] = useState(1);
  const [totalPages2, setTotalPages2] = useState(1);
  const [userBetData, setUserBetData] = useState([]);
  const [wallet, setWallet] = useState(0);
  const [winAmount, setWinAmount] = useState(0);
  const [loseAmount, setLoseAmount] = useState(0);
  const [winStatus, setWinStatus] = useState(0);
  const [period, setPeriod] = useState("");
  const [resultStatus, setResultStatus] = useState(0);
  const [displayResults, setDisplayResults] = useState([null, null, null]); // Three dice
  const [isSpinning, setIsSpinning] = useState(false);
  const [gameHistory, setGameHistory] = useState([]);
  const [gameStatus, setGameStatus] = useState(false);
  const [myBetDetailsActive, setMyBetDetailsActive] = useState(null);
  const [showResultPopup, setShowResultPopup] = useState(false);
  const [betPlacedActive, setBetPlacedActive] = useState(false);
  const [showHowToPlay, setShowHowToPlay] = useState(false);
  const [soundEnabled, setSoundEnabled] = useState(true);
  const [countDown, setCountDown] = useState(false);
  const [betPlaceProgress, setBetPlaceProgress] = useState(false);

  const socketRef = useRef(null);

  // Socket setup
  useEffect(() => {
    if (!token) return;

    socketRef.current = io(base_url, {
      auth: { token },
    });

    socketRef.current.on("connect", () => {
      // console.log("Socket connected for K3 user");
      socketRef.current.emit("joinRoom", "user");
    });

    // Listen for new game creation (from cron)
    socketRef.current.on("newGame", (data) => {
      console.log("New game started:", data);
      setPeriod(data.gameId);
      setTimmer(60); // Reset timer
      setDisplayResults([null, null, null]); // Reset results
      setGameStatus(false); // Allow new bets
      getWithAuthK3GameData(); // Refresh other data
    });

    // Listen for new bet placed (real-time update for other users/admins)
    socketRef.current.on("newBetK3", (newBet) => {
      console.log("New bet placed:", newBet);
      toast.success(`New bet on ${newBet.bet} for ₹${newBet.betAmount}`); // Optional notification
      // Update local game bets if needed, or refresh
      getWithAuthK3GameData(); // Refresh to include new bet in totals/history
    });

    socketRef.current.on("gameUpdated", () => {
      getWithAuthK3GameData(); // Refresh on game processed
    });

    return () => {
      if (socketRef.current) {
        socketRef.current.disconnect();
      }
    };
  }, []);

  const audioFiles = {
    bet: new Audio("/assets/k3/audio/bet.mp3"),
    spin: new Audio("/assets/k3/audio/spin2.mp3"),
    click: new Audio("/assets/k3/audio/click.mp3"),
    countdown1: new Audio("/assets/k3/audio/countdown1.mp3"),
  };

  useEffect(() => {
    Object.values(audioFiles).forEach((audio) => {
      audio.preload = "auto";
      audio.load();
      audio.onerror = () => console.error(`Failed to load audio: ${audio.src}`);
    });
  }, []);

  function playSound(audio) {
    if (soundEnabled) {
      try {
        audio.currentTime = 0;
        audio
          .play()
          .catch((error) =>
            console.error(`Error playing ${audio.src}:`, error),
          );
      } catch (error) {
        console.error(`Error playing ${audio.src}:`, error);
      }
    }
  }

  const stopSound = (audio) => {
    if (!audio) return;
    audio.pause();
    audio.currentTime = 0;
  };

  const intervalsRef = useRef([]);

  useEffect(() => {
    let interval = null;
    if (timmer > 0) {
      interval = setInterval(() => {
        setTimmer((prev) => prev - 1);
      }, 1000);
    } else if (timmer === 0) {
      clearInterval(interval);
      setTimmer(60);
      setGameStatus(true);
      setIsSpinning(true);
      setResultStatus(1);
      playSound(audioFiles.spin);
      const startTime = Date.now();
      intervalsRef.current = [];
      for (let i = 0; i < 3; i++) {
        const intId = setInterval(() => {
          const randomDie = Math.floor(Math.random() * 6) + 1;
          setDisplayResults((prev) => {
            const updated = [...prev];
            updated[i] = getDiceDisplay(randomDie);
            return updated;
          });
        }, 60);
        intervalsRef.current.push(intId);
      }
      setTimeout(() => {
        intervalsRef.current.forEach((id) => clearInterval(id));
        intervalsRef.current = [];
        setIsSpinning(false);
      }, 3000);
      resetGame();
    }

    if (timmer <= 15) {
      if (countDown === false) {
        playSound(audioFiles.countdown1);
        setCountDown(true);
      }
    } else {
      if (countDown === true) {
        setCountDown(false);
      }
    }

    if (timmer === 9) {
      stopSound(audioFiles.countdown1);
      playSound(audioFiles.countdown1);
    }

    if (timmer < 0) {
      setTimmer(60);
    }

    return () => clearInterval(interval);
  }, [timmer]);

  useEffect(() => {
    return () => {
      intervalsRef.current.forEach((id) => clearInterval(id));
      intervalsRef.current = [];
    };
  }, []);

  const getK3GameData = async () => {
    try {
      const response = await axios.get(`${base_url}/api/get/k3GameData`, {
        params: { page, limit },
        headers: { "Content-Type": "application/json" },
      });

      if (response.data?.success === true) {
        const resultDice = response.data.result
          ? response.data.result
              .split(",")
              .map((numStr) => getDiceDisplay(parseInt(numStr.trim())))
          : Array(3).fill(null);
        setDisplayResults(resultDice);
        setResultStatus(response.data.result ? 1 : 0);
        setPeriod(response.data.gameId);
        setTimmer(response.data.timmer);
        setWallet(response.data.money);
        setWallet(response.data.money);
        setGameHistory(response.data.k3Data);
        setUserBetData(response.data.k3UserBetData);
        setTotalPages(response.data.totalPages);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const getWithAuthK3GameData = async () => {
    try {
      const response = await axios.get(
        `${base_url}/api/get/getWithAuthK3GameData`,
        {
          params: { page, limit, page2 },
          headers: {
            Authorization: token,
          },
        },
      );

      if (response.data?.success === true) {
        setPeriod(response.data.gameId);
        const resultDice = response.data.result
          ? response.data.result
              .split(",")
              .map((numStr) => getDiceDisplay(parseInt(numStr.trim())))
          : Array(3).fill(null);
        setDisplayResults(resultDice);
        setResultStatus(response.data.result ? 1 : 0);
        setTimmer(response.data.timmer);
        setWallet(response.data.money);
        setWinAmount(response.data.winAmount);
        setLoseAmount(response.data.loseAmount);
        setWinStatus(response.data.winStatus);
        setGameHistory(response.data.k3Data);
        setUserBetData(response.data.k3UserBetData);
        setTotalPages(response.data.totalPages);
        setTotalPages2(response.data.totalPages2);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  useEffect(() => {
    getWithAuthK3GameData();
    getK3GameData();
  }, [page]);

  const total = Number(balance || 0);

  const handleBalanceSelect = (value) => {
    playSound(audioFiles.click);
    setBalance(value);
  };

  const placeBet = async () => {
    playSound(audioFiles.click);

    if (gameStatus === true) {
      toast.error("Game is processing, please wait for the next round!");
      return;
    }

    if (betPlaceProgress === true) return toast.error("Bet is processing");
    setBetPlaceProgress(true);

    try {
      const response = await axios.post(
        `${base_url}/api/place/k3Bet`,
        {
          game_id: period,
          bet: Array.isArray(selected) ? selected.join(",") : selected,
          amount: total,
          bet_type: activeType,
        },
        {
          headers: {
            Authorization: token,
          },
        },
      );

      if (response.data?.success === true) {
        playSound(audioFiles.bet);
        toast.success(`Bet Placed on ${selected} for ₹${total}`);
        setBetPlacedActive(true);
        setPopupActive(false);
        getWithAuthK3GameData();
        setBetPlaceProgress(false);
      } else {
        toast.error(response.data?.message || "Failed to place bet");
        setBetPlaceProgress(false);
      }
    } catch (error) {
      console.error("Bet placement error:", error);
      toast.error(
        error.response?.data?.message ||
          "Failed to place bet, please try again",
      );
      setBetPlaceProgress(false);
    }
  };

  const resetGame = () => {
    setTimeout(() => {
      intervalsRef.current.forEach((id) => clearInterval(id));
      intervalsRef.current = [];
      setIsSpinning(false);
      getWithAuthK3GameData();
      getK3GameData();

      if (betPlacedActive === true) {
        setShowResultPopup(true);
        setTimeout(() => {
          setShowResultPopup(false);
          setWinAmount(0);
          setLoseAmount(0);
          setWinStatus(0);
        }, 3000);
        setBetPlacedActive(false);
      }
      setGameStatus(false);
    }, 3000);
  };

  const pendingBetMap = React.useMemo(() => {
    const map = {};

    if (!Array.isArray(userBetData)) return map;

    userBetData.forEach((bet) => {
      if (bet.status === 0) {
        map[bet.bet] = (map[bet.bet] || 0) + Number(bet.betAmount || 0);
      }
    });

    return map;
  }, [userBetData]);

  const getOdds = (num) => {
    const oddsMap = {
      3: 207,
      4: 69,
      5: 34.5,
      6: 20.7,
      7: 13.8,
      8: 9.8,
      9: 8,
      10: 7.6,
      11: 7.6,
      12: 8,
      13: 9.8,
      14: 13.8,
      15: 20.7,
      16: 34.5,
      17: 69,
      18: 207,
    };
    return oddsMap[num] || 1.92;
  };

  return (
    <>
      <div
        className="k3-container"
        style={{
          overflow:
            popupActive === true || countDown === true ? "hidden" : "scroll",
        }}
      >
        {countDown && (
          <div className="count-down text-white">
            <div className="outer-circle">{timmer}</div>
          </div>
        )}

        <div className="header">
          <span
            className="title"
            onClick={() => {
              playSound(audioFiles.click);
              // navigate(-1);
            }}
          >
            <ArrowLeft /> Back
          </span>
          <div className="header-right">
            <span className="money">₹{parseFloat(wallet).toFixed(2)}</span>
          </div>
        </div>

        <div className="period_div">
          <div className="period_div_left">
            <span>Game ID :-</span>
            <span>{period}</span>
          </div>
          <div>
            <button
              className="how-to-play-btn"
              onClick={() => {
                playSound(audioFiles.click);
                setShowHowToPlay(true);
              }}
            >
              ℹ️ How to Play
            </button>
          </div>
          <div className="period_div_right">
            <span id="timmer">{timmer}s</span>
          </div>
        </div>

        {/* <div className="history-section">
          <div className="history-icon-section pb-2">
            {(Array.isArray(gameHistory) ? gameHistory : [])
              .slice(0, 30)
              .map((item, index) => {
                let n1 = null;
                let n2 = null;

                if (item.result) {
                  const parts = item.result.split(",");
                  n1 = parseInt(parts[0], 10);
                  n2 = parseInt(parts[1], 10);
                }

                const diceIcon = (n) =>
                  n === 1
                    ? "⚀"
                    : n === 2
                      ? "⚁"
                      : n === 3
                        ? "⚂"
                        : n === 4
                          ? "⚃"
                          : n === 5
                            ? "⚄"
                            : n === 6
                              ? "⚅"
                              : "❓";

                return (
                  <div
                    key={index}
                    className={`history-icon-card ${index === 0 ? "latest" : ""}`}
                  >
                    <div className="history-result-inline">
                      <span className="sum">{n1 && n2 ? n1 + n2 : "?"}</span>
                    </div>
                  </div>
                );
              })}
          </div>
        </div> */}

        {/* Top Stamps - Three Dice */}
        <div className="stamps-row">
          {[0, 1, 2].map((_, index) => (
            <div
              key={index}
              className={
                resultStatus === 1 ? "stamp dice-stamp" : "stamp empty-stamp"
              }
            >
              <div className={`stamp-content ${isSpinning ? "spinning" : ""}`}>
                {displayResults[index] && (
                  <img src={displayResults[index]} alt={`Dice ${index + 1}`} />
                )}
              </div>
            </div>
          ))}
        </div>

        <div className="k3-board-new">
          {/* TOP FILTER */}
          <div className="k3-tabs-row">
            {["TOTAL", "2SAME", "3SAME", "DIFF"].map((type) => (
              <button
                key={type}
                className={`k3-tab ${activeType === type ? "active" : ""}`}
                onClick={() => {
                  playSound(audioFiles.click);
                  setActiveType(type); // 👈 change tab
                  setSelected([]); // reset selection
                }}
              >
                {type}
              </button>
            ))}
          </div>

          {/* NUMBER GRID (3-18) */}
          {activeType === "TOTAL" && (
            <div className="k3-grid">
              {[3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18].map(
                (num) => (
                  <div
                    key={num}
                    className={`k3-box ${selected === num ? "active" : ""}`}
                    onClick={() => {
                      playSound(audioFiles.click);
                      setSelected(num);
                      setPopupActive(true);
                    }}
                  >
                    <div className="num">{num}</div>
                    {/* <div className="odds">Odds {getOdds(num)}</div> */}
                  </div>
                ),
              )}
            </div>
          )}

          {activeType === "2SAME" && (
            <div className="k3-grid">
              {["11", "22", "33", "44", "55", "66"].map((num) => (
                <div
                  key={num}
                  className={`k3-box ${selected === num ? "active" : ""}`}
                  onClick={() => {
                    setSelected(num);
                    setPopupActive(true);
                  }}
                >
                  <div className="num">{num}</div>
                </div>
              ))}
            </div>
          )}

          {activeType === "3SAME" && (
            <div className="k3-grid">
              {["111", "222", "333", "444", "555", "666"].map((num) => (
                <div
                  key={num}
                  className={`k3-box ${selected === num ? "active" : ""}`}
                  onClick={() => {
                    setSelected(num);
                    setPopupActive(true);
                  }}
                >
                  <div className="num">{num}</div>
                </div>
              ))}
            </div>
          )}

          {activeType === "DIFF" && (
            <div className="k3-grid">
              {[1, 2, 3, 4, 5, 6].map((num) => {
                const isActive = selected.includes(num);

                return (
                  <div
                    key={num}
                    className={`k3-box ${isActive ? "active" : ""}`}
                    onClick={() => {
                      playSound(audioFiles.click);

                      let updated = [...selected];

                      if (isActive) {
                        // ❌ remove if already selected
                        updated = updated.filter((n) => n !== num);
                      } else {
                        // ✅ add if less than 3
                        if (updated.length < 3) {
                          updated.push(num);
                        } else {
                          toast.error("You can select only 3 numbers");
                          return;
                        }
                      }

                      setSelected(updated);

                      // 🎯 OPEN POPUP ONLY WHEN 3 SELECTED
                      if (updated.length === 3) {
                        setTimeout(() => {
                          setPopupActive(true);
                        }, 150);
                      }
                    }}
                  >
                    <div className="num">{num}</div>
                  </div>
                );
              })}
            </div>
          )}

          {/* BOTTOM OPTIONS */}
          {activeType === "TOTAL" && (
            <div className="k3-bottom">
              {["BIG", "SMALL", "ODD", "EVEN"].map((type) => (
                <div
                  key={type}
                  className={`k3-bottom-btn ${selected === type ? "active" : ""}`}
                  onClick={() => {
                    playSound(audioFiles.click);
                    setSelected(type);
                    setPopupActive(true);
                  }}
                >
                  {type}
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Tabs */}
        <div className="k3-tabs">
          <button
            className={`tab ${activeTab === "game" ? "active" : ""}`}
            onClick={() => {
              playSound(audioFiles.click);
              setActiveTab("game");
            }}
          >
            Game History
          </button>
          <button
            className={`tab ${activeTab === "my" ? "active" : ""}`}
            onClick={() => {
              playSound(audioFiles.click);
              setActiveTab("my");
            }}
          >
            My History
          </button>
        </div>

        {/* Tab Content */}
        <div className="tab-content">
          {activeTab === "game" ? (
            <div className="history-table">
              <table>
                <thead>
                  <tr>
                    <th>Game ID</th>
                    <th>Big/Small</th>
                    <th>Odd/Even</th>
                    <th>Dice</th>
                  </tr>
                </thead>
                <tbody>
                  {gameHistory && gameHistory.length > 0 ? (
                    gameHistory.map((row, i) => {
                      let n1 = 0,
                        n2 = 0,
                        n3 = 0,
                        sum = 0;

                      if (row.result) {
                        const parts = row.result
                          .split(",")
                          .map((n) => parseInt(n.trim()) || 0);
                        [n1, n2, n3] = parts;
                        sum = n1 + n2 + n3;
                      }

                      const bigSmall = sum >= 11 ? "BIG" : "SMALL";
                      const oddEven = sum % 2 === 0 ? "EVEN" : "ODD";

                      const diceIcon = (n) =>
                        n === 1
                          ? "⚀"
                          : n === 2
                            ? "⚁"
                            : n === 3
                              ? "⚂"
                              : n === 4
                                ? "⚃"
                                : n === 5
                                  ? "⚄"
                                  : n === 6
                                    ? "⚅"
                                    : "❓";

                      return (
                        <tr key={i}>
                          <td>{row.game_id}</td>

                          {/* BIG / SMALL */}
                          <td>
                            <span
                              className={
                                bigSmall === "BIG" ? "greenColor" : "blueColor"
                              }
                            >
                              {bigSmall}
                            </span>
                          </td>

                          {/* ODD / EVEN */}
                          <td>
                            <span
                              className={
                                oddEven === "ODD"
                                  ? "orangeColor"
                                  : "purpleColor"
                              }
                            >
                              {oddEven}
                            </span>
                          </td>

                          {/* 🎲 DICE DISPLAY */}
                          <td style={{ fontSize: "20px" }}>
                            {diceIcon(n1)} {diceIcon(n2)} {diceIcon(n3)}
                            <div style={{ fontSize: "12px", color: "#aaa" }}>
                              Sum: {sum}
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td
                        colSpan="4"
                        style={{ textAlign: "center", color: "#888" }}
                      >
                        No game history found!
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>

              <div className="pagination">
                <button
                  onClick={() => {
                    playSound(audioFiles.click);
                    setPage((prev) => Math.max(prev - 1, 1));
                  }}
                  disabled={page === 1}
                >
                  <ArrowLeft />
                </button>
                <span>
                  Page {page} of {totalPages}
                </span>
                <button
                  onClick={() => {
                    playSound(audioFiles.click);
                    setPage((prev) => Math.min(prev + 1, totalPages));
                  }}
                  disabled={page === totalPages}
                >
                  <ArrowRight />
                </button>
              </div>
            </div>
          ) : (
            <div className="history-table">
              <table>
                <thead>
                  <tr>
                    <th>Details</th>
                  </tr>
                </thead>
                <tbody>
                  {userBetData.length > 0 ? (
                    userBetData.map((row, i) => {
                      let n1 = null;
                      let n2 = null;
                      let n3 = null;
                      let sum = null;
                      if (row.result) {
                        const parts = row.result.split(",");
                        n1 = parseInt(parts[0] || 0);
                        n2 = parseInt(parts[1] || 0);
                        n3 = parseInt(parts[2] || 0);
                        sum = n1 + n2 + n3;
                      }

                      const diceIcon = (n) =>
                        n === 1
                          ? "⚀"
                          : n === 2
                            ? "⚁"
                            : n === 3
                              ? "⚂"
                              : n === 4
                                ? "⚃"
                                : n === 5
                                  ? "⚄"
                                  : n === 6
                                    ? "⚅"
                                    : "❓";

                      return (
                        <tr key={i}>
                          <td
                            onClick={() => {
                              playSound(audioFiles.click);
                              setMyBetDetailsActive(
                                myBetDetailsActive === row.id ? null : row.id,
                              );
                            }}
                          >
                            {/* My Bets */}
                            <div className="myBetTr">
                              <div className="my_bet_left_side_div">
                                <div className="myBetNumber">{row.bet}</div>
                                <div>
                                  <h5>{row.game_id}</h5>
                                  <h5>
                                    {new Date(row.created_at).toLocaleString()}
                                  </h5>
                                </div>
                              </div>
                              <div className="my_bet_right_side_div">
                                <div
                                  className={
                                    row.status === 1
                                      ? "myBetStatusWin"
                                      : row.status === 2
                                        ? "myBetStatusLose"
                                        : "myBetStatusPending"
                                  }
                                >
                                  <h5>
                                    {row.status === 1
                                      ? "Win"
                                      : row.status === 2
                                        ? "Lose"
                                        : "Pending"}
                                  </h5>
                                </div>
                                <h5
                                  className={
                                    row.status === 1
                                      ? "greenColor"
                                      : row.status === 2
                                        ? "redColor"
                                        : "orangeColor"
                                  }
                                >
                                  {row.status === 1
                                    ? "+" + parseFloat(row.winAmount).toFixed(2)
                                    : "-" +
                                      parseFloat(row.betAmount).toFixed(2)}
                                </h5>
                              </div>
                            </div>

                            {/* Details Section */}
                            <div
                              className="myBetDetails"
                              style={{
                                display:
                                  myBetDetailsActive === row.id
                                    ? "block"
                                    : "none",
                              }}
                            >
                              <h5>Details</h5>

                              <div className="myBetDetailRow">
                                <p>Game ID</p>
                                <p>{row.game_id}</p>
                              </div>
                              <div className="myBetDetailRow">
                                <p>Bet Amount</p>
                                <p className="redColor">
                                  {parseFloat(row.betAmount).toFixed(2)}
                                </p>
                              </div>
                              <div className="myBetDetailRow">
                                <p>Bet On</p>
                                <p>
                                  {row.bet_type} - {row.bet}
                                </p>
                              </div>
                              <div className="myBetDetailRow">
                                <p>Result</p>
                                <p className="orangeColor">
                                  {row.result ? (
                                    <>
                                      <span style={{ fontSize: "20px" }}>
                                        {diceIcon(n1)} {diceIcon(n2)}{" "}
                                        {diceIcon(n3)}
                                      </span>
                                      <span
                                        style={{
                                          marginLeft: "8px",
                                          fontSize: "15px",
                                        }}
                                      >
                                        = {sum}
                                      </span>
                                    </>
                                  ) : (
                                    "Pending"
                                  )}
                                </p>
                              </div>
                              <div className="myBetDetailRow">
                                <p>Win/Lose</p>
                                <p
                                  className={
                                    row.status === 1
                                      ? "greenColor"
                                      : row.status === 2
                                        ? "redColor"
                                        : "orangeColor"
                                  }
                                >
                                  {row.status === 1
                                    ? "+" + parseFloat(row.winAmount).toFixed(2)
                                    : "-" +
                                      parseFloat(row.betAmount).toFixed(2)}
                                </p>
                              </div>
                              <div className="myBetDetailRow">
                                <p>Available Balance</p>
                                <p className="greenColor">
                                  {parseFloat(row.current_money).toFixed(2)}
                                </p>
                              </div>
                              <div className="myBetDetailRow">
                                <p>Time</p>
                                <p>
                                  {new Date(row.created_at).toLocaleString()}
                                </p>
                              </div>
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td>Bet not available!</td>
                    </tr>
                  )}
                </tbody>
              </table>

              <div className="pagination">
                <button
                  onClick={() => {
                    playSound(audioFiles.click);
                    setPage2((prev) => Math.max(prev - 1, 1));
                  }}
                  disabled={page2 === 1}
                >
                  <ArrowLeft />
                </button>
                <span>
                  Page {page2} of {totalPages2}
                </span>
                <button
                  onClick={() => {
                    playSound(audioFiles.click);
                    setPage2((prev) => Math.min(prev + 1, totalPages2));
                  }}
                  disabled={page2 === totalPages2}
                >
                  <ArrowRight />
                </button>
              </div>
            </div>
          )}
        </div>

        {/* Popup Section */}
        {popupActive && (
          <div className="">
            <div className="lucky7-bet">
              <div className="popup">
                <div className="popup-header">
                  <h2>Place Bet</h2>
                  <div className="select-box">
                    <span>Selected</span>
                    <strong>
                      {activeType} :{" "}
                      {Array.isArray(selected) ? selected.join(", ") : selected}
                    </strong>
                  </div>
                </div>

                <div className="popup-body">
                  <div className="balance-section">
                    <label>Enter Amount</label>
                    <input
                      type="number"
                      min="1"
                      value={balance}
                      onChange={(e) => setBalance(e.target.value)}
                      className="bet-input"
                      placeholder="Enter amount"
                    />
                  </div>

                  <div className="balance-options">
                    {[10, 50, 100, 500, 1000].map((val) => (
                      <button
                        key={val}
                        className={Number(balance) === val ? "active" : ""}
                        onClick={() => setBalance(val)}
                      >
                        ₹{val}
                      </button>
                    ))}
                  </div>
                </div>

                <div className="popup-footer">
                  <button
                    className="cancel"
                    onClick={() => {
                      playSound(audioFiles.click);
                      setPopupActive(false);
                    }}
                  >
                    Cancel
                  </button>
                  <button className="total" onClick={placeBet}>
                    Total amount ₹{total.toFixed(2)}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* 🎉 Win / Lose Popup */}
      {showResultPopup && (
        <div className="result-popup-overlay">
          <div
            className={`result-popup ${
              winStatus === 1
                ? "popup-win"
                : winStatus === 2
                  ? "popup-lose"
                  : "popup-pending"
            }`}
          >
            <div className="popup-emoji">
              {winStatus === 1 ? "🎉" : winStatus === 2 ? "😢" : "⏳"}
            </div>
            <h2>
              {winStatus === 1
                ? "You Win!"
                : winStatus === 2
                  ? "You Lose!"
                  : ""}
            </h2>
            <p style={{ color: "#fff" }}>
              {winStatus === 1
                ? `You earned ₹${winAmount.toFixed(2)}`
                : winStatus === 2
                  ? `You lost your bet`
                  : `Waiting for result...`}
            </p>
          </div>
        </div>
      )}

      {/* 🧭 How to Play Popup */}
      {showHowToPlay && (
        <div
          className="howto-overlay"
          onClick={() => {
            playSound(audioFiles.click);
            setShowHowToPlay(false);
          }}
        >
          <div className="howto-popup" onClick={(e) => e.stopPropagation()}>
            <h2>How to Play K3 🎲</h2>
            <div className="howto-content">
              <h3>🎮 Quick Start</h3>
              <ol>
                <li>
                  <strong>Join the Game:</strong> Log in and open K3.
                </li>
                <li>
                  <strong>Select a Side:</strong> Tap a side to bet on the dice
                  total.
                </li>
              </ol>
              <h3>💰 Customize Your Bet</h3>
              <ul>
                <li>
                  <b>Balance:</b> Choose ₹10, ₹50, ₹100, or ₹1,000.
                </li>
              </ul>
              <h3>⏱️ Watch the Round</h3>
              <p>
                Timer counts down. When 0, two dice roll, sum determines winner.
              </p>
              <h3>🏆 Check Results</h3>
              <p>View Game History & My History for past bets.</p>
            </div>

            <button
              className="close-howto"
              onClick={() => {
                playSound(audioFiles.click);
                setShowHowToPlay(false);
              }}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default K3;
